import React from "react";
import { Modal, Tabs, Tab } from "react-bootstrap";
import { Elements } from "react-stripe-elements";
import CardPaymentMethod from "home/components/card-payment-method";
import BankPaymentMethod from "home/components/bank-payment-method";
import "./link-payment-method-layout.css";

function LinkPaymentMethodLayout(props) {
  const cardElement = (
    <Elements>
      <CardPaymentMethod {...props} />
    </Elements>
  );

  const bankElement = (
    <Elements>
      <BankPaymentMethod {...props} />
    </Elements>
  );

  return (
    <div className="link-payment-method">
      <Modal
        show={props.show}
        onHide={() => props.handleShow("LinkPaymentMethod", false)}
        onEnter={() => props.resetState()}
      >
        <Modal.Header closeButton>
          <Modal.Title className="text-primary">
            Link New Payment Method
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <h4>Select Payment Type</h4>
            <Tabs defaultActiveKey={"card"} id="uncontrolled-tab-example">
              <Tab eventKey={"card"} title="Link new credit/debit card">
                {cardElement}
              </Tab>
              <Tab eventKey={"bank"} title="Link new bank account">
                {bankElement}
              </Tab>
            </Tabs>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default LinkPaymentMethodLayout;



// WEBPACK FOOTER //
// ./src/home/components/link-payment-method-layout.js